import { Button } from "@/components/elements/Button";
import { Form } from "@/components/elements/Form";
import { FormField } from "@/components/elements/FormField";
import { Input } from "@/components/elements/Input";
import { recoverSchema } from "@/features/auth/schema/recoverSchema";
import { requestResetPasswordApi } from "@/features/auth/services/requestResetPassword";
import { TRecoverRequest } from "@/features/auth/types/recoverRequest";
import { AppRoutes } from "@/routes/config";
import { text } from "@/theme/colors";
import { setErrorForm, showError } from "@/utils/error";
import { yupResolver } from "@hookform/resolvers/yup";
import { Paper, Stack, Typography, styled } from "@mui/material";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

export const RecoverForm = () => {
  const navigate = useNavigate();
  const methods = useForm<TRecoverRequest>({
    mode: "all",
    reValidateMode: "onBlur",
    resolver: yupResolver(recoverSchema),
  });
  const { control } = methods;

  const onSubmit = async (data: TRecoverRequest) => {
    try {
      await requestResetPasswordApi(data);
      navigate(AppRoutes.recoverSuccess, { state: { email: data.email } });
    } catch (error) {
      showError(error);
      setErrorForm(methods, error);
    }
  };

  return (
    <Container
      elevation={0}
      sx={{
        width: 464,
        p: 4,
        borderRadius: "16px",
      }}
    >
      <Stack gap={3}>
        <Typography variant="head20Bold" color={text.primary} textAlign="center">
          パスワード再発行
        </Typography>
        <Typography fontSize="14px" color={text.secondary} mt={1} mb="12px">
          登録されたメールアドレスを入力してください。
        </Typography>
        <Form methods={methods} onSubmit={onSubmit} enableBlocker={false} schema={recoverSchema}>
          <Stack gap="44px">
            <FormField control={control} name="email" label="メールアドレス">
              <Input size="lg" placeholder="info@irohana.co.jp" />
            </FormField>
            <Button type="submit" variant="primary" fullWidth size="sm">
              <Typography variant="body14Semi">送信</Typography>
            </Button>
          </Stack>
        </Form>
      </Stack>
    </Container>
  );
};

const Container = styled(Paper)`
  box-shadow:
    0 4px 4px -1px rgba(12, 12, 13, 0.05),
    0 4px 4px -1px rgba(12, 12, 13, 0.1) !important;
`;
